var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fuel-station 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1335 4.84375C19.1335 3.37222 17.9409 2.17969 16.4694 2.17969C13.3781 2.17969 7.36508 2.17969 4.2738 2.17969C2.80227 2.17969 1.60974 3.37222 1.60974 4.84375V27.125C1.60974 28.5965 2.80227 29.7891 4.2738 29.7891H16.4694C17.9409 29.7891 19.1335 28.5965 19.1335 27.125C19.1335 22.2812 19.1335 9.6875 19.1335 4.84375ZM17.6803 4.84375V27.125C17.6803 27.7934 17.1378 28.3359 16.4694 28.3359H4.2738C3.60537 28.3359 3.06287 27.7934 3.06287 27.125C3.06287 22.2812 3.06287 9.6875 3.06287 4.84375C3.06287 4.17531 3.60537 3.63281 4.2738 3.63281H16.4694C17.1378 3.63281 17.6803 4.17531 17.6803 4.84375Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9785 15.8575C10.8448 15.6521 10.6162 15.5281 10.3711 15.5281C10.125 15.5281 9.89638 15.6521 9.76269 15.8575C9.76269 15.8575 8.38222 17.9723 7.55394 19.8749C7.16063 20.7768 6.901 21.6419 6.901 22.2551C6.901 24.1703 8.45584 25.7252 10.3711 25.7252C12.2853 25.7252 13.8402 24.1703 13.8402 22.2551C13.8402 21.6419 13.5805 20.7768 13.1872 19.8749C12.3589 17.9723 10.9785 15.8575 10.9785 15.8575ZM10.3711 17.6342C10.8167 18.382 11.4173 19.4496 11.8552 20.4552C12.1536 21.141 12.387 21.7882 12.387 22.2551C12.387 23.3682 11.4842 24.272 10.3711 24.272C9.25797 24.272 8.35413 23.3682 8.35413 22.2551C8.35413 21.7882 8.58759 21.141 8.88597 20.4552C9.32384 19.4496 9.92447 18.382 10.3711 17.6342Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2266 12.5938V6.29688C16.2266 5.62844 15.6841 5.08594 15.0157 5.08594C13.2864 5.08594 7.4255 5.08594 5.69531 5.08594C5.02688 5.08594 4.48438 5.62844 4.48438 6.29688V12.5938C4.48438 12.9948 4.80988 13.3203 5.21094 13.3203H15.5C15.9011 13.3203 16.2266 12.9948 16.2266 12.5938ZM14.7735 6.53906V11.8672H5.9375V6.53906H14.7735Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0625 28.396H1.9375C1.53644 28.396 1.21094 28.7215 1.21094 29.1226C1.21094 29.5236 1.53644 29.8491 1.9375 29.8491H29.0625C29.4636 29.8491 29.7891 29.5236 29.7891 29.1226C29.7891 28.7215 29.4636 28.396 29.0625 28.396Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4062 14.7734C18.0439 14.7734 17.6797 15.2578 17.6797 15.5C17.6797 15.9011 18.0052 16.2266 18.4062 16.2266C19.6104 16.2266 20.5859 17.2021 20.5859 18.4062V21.3144C20.5859 22.0207 20.8669 22.6978 21.3658 23.1967C21.8647 23.6956 22.5418 23.9766 23.2481 23.9766H23.2519C24.7225 23.9766 25.9141 22.785 25.9141 21.3144V14.0469C25.9141 13.6458 25.5886 13.3203 25.1875 13.3203C24.7864 13.3203 24.4609 13.6458 24.4609 14.0469V21.3144C24.4609 21.9819 23.9194 22.5234 23.2519 22.5234H23.2481C22.9274 22.5234 22.6203 22.3956 22.3936 22.1689C22.166 21.9422 22.0391 21.6351 22.0391 21.3144V18.4062C22.0391 16.4 20.4125 14.7734 18.4062 14.7734Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1875 13.3203C25.0538 13.3203 24.9453 13.2118 24.9453 13.0781V10.6562C24.9453 10.5226 25.0538 10.4141 25.1875 10.4141C25.3212 10.4141 25.4297 10.5226 25.4297 10.6562V13.0781C25.4297 13.2118 25.3212 13.3203 25.1875 13.3203ZM25.1875 8.96094C24.2517 8.96094 23.4922 9.71947 23.4922 10.6562V13.0781C23.4922 14.0149 24.2517 14.7734 25.1875 14.7734C26.1233 14.7734 26.8828 14.0149 26.8828 13.0781V10.6562C26.8828 9.71947 26.1233 8.96094 25.1875 8.96094Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9059 9.57319C25.9059 9.57319 25.7944 8.88151 25.962 8.22857C26.0434 7.91469 26.1839 7.59113 26.5259 7.45841C26.8998 7.3131 27.0858 6.89169 26.9405 6.51776C26.7952 6.14479 26.3738 5.95879 25.9998 6.1041C25.1832 6.42185 24.7482 7.11741 24.5554 7.86626C24.3132 8.80594 24.4702 9.80182 24.4702 9.80182C24.5341 10.198 24.9061 10.4683 25.3023 10.4054C25.6985 10.3414 25.9688 9.96941 25.9059 9.57319Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelStation);
export default __webpack_public_path__ + "static/media/fuel_station.a9a1fa5e73a0721be9f45c3bbc0818a3.svg";
export { ForwardRef as ReactComponent };